import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import PPC_SAVE_USER_QUERY from './PPCUserOhidInfo.gql';

const parseResult = result => {
  const initialState = {
    ohidInfoStatus: '',
    ohidInfoStatusMessage: ''
  };

  const ppcUserInfoSave = get(result, 'core.ppcUserInfo');

  return {
    ...initialState,
    ...ppcUserInfoSave,
  };
};

export const usePPCUserInfoQuery = options => {
  const [queryResult, queryAction] = useQuery(PPC_SAVE_USER_QUERY, {
    ...options,
    requestPolicy: 'no-cache',
    onCompleted: result => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
